import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div className="pt-[34px] px-[24px] bg-[#1A1A1A] w-full flex flex-col items-center">
      {/* <div className="pt-[34px] px-[24px] bg-[#002603]"> */}
      <div className="grid grid-cols-1 md:grid-cols-6 gap-5 max-w-[1300px]">
        <div className="flex flex-col items-start mb-5 md:mb-0">
          <p className="font-[Source Sans Pro] text-[14px] font-semibold text-[#FFFFFF]">
            Customer Care
          </p>
          <p className="font-[Source Sans Pro] text-[14px] font-normal mt-[21px] text-[#999999] ">
            Help & FAQs
          </p>
          <p className="font-[Source Sans Pro] text-[14px] font-normal mt-[7px] text-[#999999]">
            Delivery Information
          </p>
          <p className="font-[Source Sans Pro] text-[14px] font-normal mt-[7px] text-[#999999]">
            Returns & Refunds
          </p>
          <p className="font-[Source Sans Pro] text-[14px] font-normal mt-[7px] text-[#999999]">
            Track Order
          </p>
          <Link to="/contactus">
            <p className="font-[Source Sans Pro] text-[14px] font-normal mt-[7px] text-[#999999]">
              Conatct Us
            </p>
          </Link>
        </div>

        <div className="flex flex-col items-start mb-5 md:mb-0">
          <p className="font-[Source Sans Pro] text-[14px] font-semibold text-[#FFFFFF]">
            Comapny
          </p>
          <Link to="/aboutus">
            <p className="font-[Source Sans Pro] text-[14px] font-normal mt-[21px] text-[#999999] ">
              About Us
            </p>
          </Link>
          <p className="font-[Source Sans Pro] text-[14px] font-normal mt-[7px] text-[#999999]">
            Careers
          </p>
          <p className="font-[Source Sans Pro] text-[14px] font-normal mt-[7px] text-[#999999]">
            Our Values
          </p>
          <p className="font-[Source Sans Pro] text-[14px] font-normal mt-[7px] text-[#999999]">
            Press & News
          </p>
        </div>

        <div className="flex flex-col items-start mb-5 md:mb-0">
          <p className="font-[Source Sans Pro] text-[14px] font-semibold text-[#FFFFFF]">
            Quick Links
          </p>
          <p className="font-[Source Sans Pro] text-[14px] font-normal mt-[21px] text-[#999999]">
            Offers & Discounts
          </p>
          <p className="font-[Source Sans Pro] text-[14px] font-normal mt-[7px] text-[#999999]">
            Gift Cards
          </p>
          <p className="font-[Source Sans Pro] text-[14px] font-normal mt-[7px] text-[#999999]">
            Loyalty Program
          </p>
          <p className="font-[Source Sans Pro] text-[14px] font-normal mt-[7px] text-[#999999]">
            Best Sellers
          </p>
          <p className="font-[Source Sans Pro] text-[14px] font-normal mt-[7px] text-[#999999]">
            Blog
          </p>
          <Link to="/privacy">
            <p className="font-[Source Sans Pro] text-[14px] font-normal mt-[7px] text-[#999999]">
              Privacy Policy
            </p>
          </Link>
          <p className="font-[Source Sans Pro] text-[14px] font-normal mt-[7px] text-[#999999]">
            Terms & Conditions
          </p>
        </div>

        <div className="col-span-2 flex flex-col items-start mb-5 md:mb-0">
          <p className="font-[Source Sans Pro] text-[14px] font-semibold text-[#FFFFFF]">
            Download Our App
          </p>
          <p className="font-[Source Sans Pro] text-[14px] font-normal mt-[21px] text-[#999999]">
            Get the best shopping experience on the go!
          </p>

          <div className="grid grid-cols-2 gap-2 mt-[40px]">
            <img
              src="/images/footer/app-store.png"
              alt="t&k"
              style={{
                width: "100%",
                height: "100%",
              }}
            />
            <img
              src="/images/footer/play-store.png"
              alt="t&k"
              style={{
                width: "100%",
                height: "100%",
              }}
            />
          </div>
        </div>

        <div className="flex flex-col items-start mb-5 md:mb-0">
          <p className="font-[Source Sans Pro] text-[14px] font-semibold text-[#FFFFFF]">
            Payment Methods
          </p>
          <div className=" mt-[40px]">
            <img
              src="/images/footer/payment-method.png"
              alt="t&k"
              style={{
                width: "100%",
                height: "100%",
              }}
            />
          </div>
        </div>
      </div>
      <p className="font-[Source Sans Pro] self-start text-[14px] font-normal mt-[53px] text-center lg:text-left text-gray-400">
        © 2024 All rights reserved. T and K Food Mart Limited
      </p>
    </div>
  );
};

export default Footer;
